import FilterBar from '../../components/FilterBar/FilterBar';
import VideoCard from '../../components/VideoCard';
import VideoCardSide from '../../components/VideoCardSide';
import Pagination from '../../components/Pagination';
import useMyFavoriteList from './useMyFavoriteList';
import LoadingIndicator from '../../components/LoadingIndicator';
import styles from './MyFavoriteList.module.css';

/**
 * お気に入りとイイねした動画を表示するコンポーネント
 * フィルターとソートで管理
 */
const MyFavoriteList = () => {
  const {
    isMobile,
    videos,
    pagination,
    currentPage,
    sortOrder,
    showFavorites,
    showLiked,
    specialty,
    specialtyOptions,
    isLoading,
    handleSortOrderChange,
    handlePageChange,
    handleFavoriteToggle,
    handleLikedToggle,
    handleSpecialtyChange,
  } = useMyFavoriteList();

  const favoriteFilters = (
    <>
      <label className={`${styles['my-favorite-list__filter-label']} ${showFavorites ? styles['my-favorite-list__filter-label--checked'] : ''}`}>
        <input
          type="checkbox"
          className={styles['my-favorite-list__filter-checkbox']}
          checked={showFavorites}
          onChange={handleFavoriteToggle}
          data-testid="my-favorite-list__filter-favorites"
        />
        <span className={styles['my-favorite-list__filter-checkmark']} aria-hidden="true" />
        <span>お気に入り</span>
      </label>
      <label className={`${styles['my-favorite-list__filter-label']} ${showLiked ? styles['my-favorite-list__filter-label--checked'] : ''}`}>
        <input
          type="checkbox"
          className={styles['my-favorite-list__filter-checkbox']}
          checked={showLiked}
          onChange={handleLikedToggle}
          data-testid="my-favorite-list__filter-liked"
        />
        <span className={styles['my-favorite-list__filter-checkmark']} aria-hidden="true" />
        <span>いいね</span>
      </label>
    </>
  );

  return (
    <div className={styles['my-favorite-list-container']} data-testid="my-favorite-list">
      <FilterBar
        sortOrder={sortOrder}
        onSortOrderChange={handleSortOrderChange}
        specialty={specialty}
        onSpecialtyChange={handleSpecialtyChange}
        procedure=""
        onProcedureChange={() => {}}
        specialtyOptions={specialtyOptions}
        extraFilters={favoriteFilters}
      />

      <div className={styles['my-favorite-list__content']}>
        <div className={styles['my-favorite-list-section-container']}>
          <div className={styles['my-favorite-list-section-card']}>
            <div className={styles['my-favorite-list__video-grid-container']}>
              {isLoading ? (
                <div className={`${styles['my-favorite-list__loading-container']} ${styles['my-favorite-list__grid-full-width']}`} data-testid="my-favorite-list__loading">
                  <LoadingIndicator className={styles['my-favorite-list__loading-indicator']} />
                </div>
              ) : videos.length > 0 ? (
                <div className={styles['my-favorite-list__video-grid']} data-testid="my-favorite-list__grid">
                  {videos.map((video) => (
                    <div className={styles['my-favorite-list__video-card-wrapper']} key={video.id} data-testid={`my-favorite-list__video-${video.id}`}>
                      {isMobile ? (
                        <VideoCardSide
                          video={video}
                          showUserIcon={true}
                          hideVisibilityToggle={true}
                        />
                      ) : (
                        <VideoCard
                          video={video}
                          hideVisibilityToggle={true}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className={styles['my-favorite-list__empty-container']} data-testid="my-favorite-list__empty">
                  <p className={styles['my-favorite-list__empty-message']}>
                    {!showFavorites && !showLiked
                      ? 'フィルターを選択してください。'
                      : specialty
                        ? '選択した診療科の動画がありません。'
                        : '動画がありません。'
                    }
                  </p>
                </div>
              )}
            </div>

            {!isLoading && videos.length > 0 && pagination.totalPages > 1 && (
              <div className={styles['my-favorite-list-pagination-container']}>
                <Pagination
                  currentPage={currentPage}
                  totalPages={pagination.totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyFavoriteList;
